import { FC } from 'react';
import { RoadmapEventProps } from '.';
import styles from './RoadmapEvent.module.scss';


export const RoadmapEvent: FC<RoadmapEventProps> = ({ date, description, className, above }) => {
	return <div className={[styles.event, className, above && styles.above].join(" ")}>
		<div className={styles.event__star}></div>
		<h5 className={styles.event__header}>{ date }</h5>
		<p className={styles.event__description}>{ description }</p>
	</div>;
};
